import React, { useRef, useState } from 'react'
import { useLogin, useNotify, useTranslate, Notification } from 'react-admin'
import { Link, makeStyles } from '@material-ui/core'
import { Form, Formik } from 'formik'
import ReCAPTCHA from 'react-google-recaptcha'
import ButtonWithLoader from '../../../ui/ButtonWithLoader/ButtonWithLoader'
import loginFormStyles from './loginForm.styles'
import MyTextField from '../../fields/MyTextField'
import MyTextFieldPassword from '../../fields/MyTextFieldPassword'
import getQueryParameterByName from '../../../../utils/helpers/getQueryParameterByName'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { useLocation } from 'react-router-dom'
import afterLoginPath from '../../../../utils/helpers/afterLoginPath'
import GoogleLoginButton from './GoogleLoginButton/GoogleLoginButton'

const LoginForm = () => {
  const reCaptchaRef = useRef()
  const [loading, setLoading] = useState(false)
  const translate = useTranslate()
  const login = useLogin()
  const notify = useNotify()
  const location = useLocation()
  const useStyles = makeStyles(loginFormStyles)
  const classes = useStyles()

  const onSubmit = async (data) => {
    const captchaToken = await reCaptchaRef.current.executeAsync()

    setLoading(true)
    const { email, password } = data
    login({ username: email, password, captchaToken }, afterLoginPath(location))
      .catch((errorMessage) => {
        reCaptchaRef.current.reset()
        notify(errorMessage, 'error', undefined, false, 3000)
      })
      .finally(() => setLoading(false))
    reCaptchaRef.current.reset()
  }

  return (
    <Formik
      initialValues={{
        email: getQueryParameterByName('email') || '',
        password: '',
      }}
      onSubmit={onSubmit}
    >
      {() => (
        <>
          <Form>
            <div className={classes.formWrapper}>
              <MyTextField
                label={translate('ra.formFields.email')}
                name='email'
                required
                autoComplete='email'
              />
              <MyTextFieldPassword
                label={translate('ra.formFields.password')}
                name='password'
                type='password'
                required
                autoComplete='current-password'
              />
              <ButtonWithLoader
                fullWidth
                label={translate('ra.buttons.login')}
                style={{ marginTop: 10 }}
                loading={loading}
              />
              <GoogleOAuthProvider clientId='46319718455-76qepinjbno546bp3kk6vrn91k6b0a00.apps.googleusercontent.com'>
                <GoogleLoginButton />
              </GoogleOAuthProvider>
              <div className={classes.linksWrapper}>
                <Link href='/forgot-password' variant='body2' className={classes.link}>
                  {translate('ra.gridLinks.forgotPassword')}
                </Link>
                <Link href='/signUp' variant='body2' className={classes.link}>
                  {translate('ra.gridLinks.signUp')}
                </Link>
              </div>
            </div>
            <ReCAPTCHA
              ref={reCaptchaRef}
              sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
              size='invisible'
            />
          </Form>
          <Notification />
        </>
      )}
    </Formik>
  )
}

export default LoginForm
